



import { Close, DateRange } from '@mui/icons-material';
import { Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MultipleInvitesModal = ({ selectedUsers, onClose }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null); // Only one campaign selected
  const brandId = localStorage.getItem('brandID');

  useEffect(() => {
    const fetchCampaigns = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://server-side-influencer.onrender.com/brand/getMyCampaigns/${brandId}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        const data = await response.json();
        if (data.success) {
          setCampaigns(data.data); // Set campaigns in state
        } else {
          console.error('Failed to fetch campaigns');
        }
      } catch (err) {
        console.error('Error fetching campaigns:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();
  }, [brandId]);

  const handleCampaignSelect = (campaignId) => {
    // If the selected campaign is the same as the one clicked, unselect it; otherwise, select it
    setSelectedCampaign(campaignId === selectedCampaign ? null : campaignId);
  };

  const handleInviteClick = async () => {
    if (!selectedCampaign) {
      toast.error("No campaign selected!");
      return;
    }

    if (selectedUsers.length === 0) {
      toast.error("No users selected!");
      return;
    }

    const requestData = {
      userIds: selectedUsers, // Array of user IDs
      campaignId: selectedCampaign, // Single campaign ID
    };

    try {
      const response = await fetch('https://server-side-influencer-production.up.railway.app/brand/invite-users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Campaign invitation sent successfully!");
        setSelectedCampaign(null); // Reset selected campaign after successful invitesss
      } else {
        toast.error(data.message || "Failed to send invitations!");
        console.error('Error:', data.message || "Unknown error");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error('Error:', error);
    }
  };

  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={true} />
      <Dialog open={true} onClose={onClose} fullWidth maxWidth="lg">
        <DialogTitle>
          Select Campaign to invite
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <p>Loading campaigns...</p>
          ) : (
            <div className="campaign-list" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              {campaigns.length > 0 ? (
                campaigns.map((campaign) => (
                  <div key={campaign._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                      <FormControlLabel
                        control={<Checkbox checked={selectedCampaign === campaign._id} onChange={() => handleCampaignSelect(campaign._id)} />}
                        label={campaign.campaignName} // Display campaign type near the checkbox
                      />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                        <DateRange sx={{ marginRight: '5px' }} />
                        <span>{new Date(campaign.startDate).toLocaleDateString()} - {new Date(campaign.endDate).toLocaleDateString()}</span>
                      </div>
                      <button
  type="button"
  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
  onClick={handleInviteClick}
  disabled={selectedCampaign !== campaign._id} // Disable if this campaign is not selected
>
  Invite
</button>

                    </div>
                  </div>
                ))
              ) : (
                <p>No campaigns found.</p>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MultipleInvitesModal;
